(function() {
  var Contacts_Handler, PlacementHandler, Router, e,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  try {
    PlacementHandler = App.loadClass('grower::handlers/placement/PlacementHandler');
  } catch (error) {
    e = error;
    PlacementHandler = (function(_this) {
      return function() {
        return null;
      };
    })(this);
  }

  Contacts_Handler = App.loadClass('grower::handlers/contacts/Contacts_Handler');

  exports.NavigationRouter = (function(superClass) {
    extend(NavigationRouter, superClass);

    function NavigationRouter() {
      return NavigationRouter.__super__.constructor.apply(this, arguments);
    }

    NavigationRouter.prototype.module_name = 'NavigationRouter';

    NavigationRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router']);
      return this.module.controller('NavigationController', [
        '$scope', '$state', '$transitions', '$rootScope', '$http', function($scope, $state, $transitions, $rootScope, $http) {
          var unregisterConfirmMapsHandler, unregisterFieldprintCompleteHandler;
          $scope.$state = $state;
          $scope.confirm = {
            showAlert: false,
            tab: null
          };
          $http.get('backend/grower/notification/notifications').then((function(_this) {
            return function(response) {
              if (response.data.includes('map_confirmation')) {
                return $scope.confirm.showAlert = true;
              }
            };
          })(this));
          $scope.isOnData = function() {
            return $state.includes('grower.data') || $state.includes('grower.zone') || ($state.includes('grower.planting-rx') && !(App.current_page instanceof PlacementHandler));
          };
          $scope.isOnFields = function() {
            return $state.includes('grower.fields-define') || (App.current_page instanceof Fields_Handler && !$state.includes('grower.data') && !$state.includes('grower.operation') && !(App.current_page instanceof PlacementHandler));
          };
          $scope.isOnOperation = function() {
            return $state.includes('grower.operation');
          };
          $scope.fieldprint = {
            showAlert: false,
            id: null
          };
          unregisterFieldprintCompleteHandler = Socket.register('fieldprintChanged', function(data) {
            if (data.newScores && data.fpcResult.dryland_status === 'success' && data.fpcResult.irrigated_status === 'success') {
              $scope.$apply(function() {
                $scope.fieldprint.showAlert = true;
                return $scope.fieldprint.id = data.fpcResult.id;
              });
            }
            return $rootScope.$broadcast('fieldprintChanged', data.fpcResult);
          });
          $scope.$on('$destroy', (function(_this) {
            return function() {
              return unregisterFieldprintCompleteHandler();
            };
          })(this));
          $scope.fieldprintButtonClicked = (function(_this) {
            return function() {
              return $scope.fieldprint.showAlert = false;
            };
          })(this);
          unregisterConfirmMapsHandler = Socket.register('mapDataStatusUpdated', function(data) {
            if (data.status === 'Success') {
              return $scope.$apply(function() {
                $scope.confirm.showAlert = true;
                return $scope.confirm.tab = data.type;
              });
            }
          });
          $scope.$on('$destroy', (function(_this) {
            return function() {
              return unregisterConfirmMapsHandler();
            };
          })(this));
          $scope.confirmMapsButtonClicked = (function(_this) {
            return function() {
              $http.post('backend/grower/notification/delete', {
                notification_name: ['map_confirmation']
              });
              return $scope.confirm.showAlert = false;
            };
          })(this);
          $scope.finishImportingFieldView = function() {
            $('#fieldview-pending').toggle('slide');
          };
          $scope.finishImportingFieldViewYield = function() {
            $('#fieldview-pending-yield').toggle('slide');
          };
          $scope.finishImportingFieldViewApplication = function() {
            $('#fieldview-pending-application').toggle('slide');
          };
          $scope.finishImportingFieldViewPlanting = function() {
            $('#fieldview-pending-planting').toggle('slide');
          };
          $scope.finishImportingJohnDeere = function() {
            $('#johndeere-pending').toggle('slide');
          };
          $scope.finishImportingJohnDeereYield = function() {
            $('#johndeere-pending-yield').toggle('slide');
          };
          $scope.finishImportingJohnDeereApplication = function() {
            $('#johndeere-pending-application').toggle('slide');
          };
          return $scope.finishImportingJohnDeerePlanting = function() {
            $('#johndeere-pending-planting').toggle('slide');
          };
        }
      ]);
    };

    return NavigationRouter;

  })(Router);

}).call(this);
